import { TRANSLATIONS, TRANSLATIONS_FORMAT, LOCALE_ID } from '@angular/core';
import { environment } from '../../environments/environment';

// use the require method provided by webpack
declare const require;
const DEFAULT_LOCAL = 'en';
const LOCAL_KEY = 'local';
const SUPPORTED_LANGUAGES = environment.supportedLanguages;

export function GetLocalizationProvider(): Object[] {
    const noProvider: Object[] = [];
    const local = getLocal();

    if (!local || local === DEFAULT_LOCAL) {
        return noProvider;
    }

    // we use the webpack raw-loader to return the content as a string
    const translations = require(`raw-loader!../../locale/messages.${local}.xlf`);
    const localizationProvider = [
        { provide: TRANSLATIONS, useValue: translations },
        { provide: TRANSLATIONS_FORMAT, useValue: 'xlf' },
        { provide: LOCALE_ID, useValue: local }
    ];

    return localizationProvider;
}

function getLocal(): string {
    readLocalFromUrl();
    const local = getLocalFromLocalStorage();
    const isSupported = SUPPORTED_LANGUAGES.some((l) => l === local);
    return (isSupported && local) ? local : DEFAULT_LOCAL;
}

function readLocalFromUrl() {
    const local = getQueryString(LOCAL_KEY);
    if (local) {
        localStorage.setItem(LOCAL_KEY, local);
    }
}

function getLocalFromLocalStorage() {
    const local = localStorage.getItem(LOCAL_KEY);
    if (local) {
        return local;
    }
    return null;
}

function getQueryString(field, url = null) {
    const href = url ? url : window.location.href;
    const reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
    const string = reg.exec(href);
    return string ? string[1] : null;
}




// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/localization/i18n-providers.ts